const translations = {
    error: "Something went wrong, and we couldn't log you into this organization"
};

export default translations;
